import { z } from "zod";
/**
 * Primitives shared by every schema in this folder.
 *
 * These encode constraints that come from the database and the JS number type rather than
 * from any one feature, so they belong here instead of being redefined per feature - a
 * second, subtly different `decimalString` is exactly how two features end up disagreeing
 * about what a stored amount means.
 */
/**
 * Money as a string, never a number.
 *
 * These values originate as `Big` instances and land in DECIMAL(19,4). A JS number cannot
 * represent every value in that range exactly, so parsing through one would introduce
 * rounding that the row then reports as fact. Strings round-trip.
 */
export const decimalString = z
    .string()
    .regex(/^-?\d+(\.\d+)?$/, "Expected a decimal string, e.g. '171.43'");
/**
 * A BIGINT primary key.
 *
 * Accepts a number or a numeric string because Sequelize returns BIGINT either way
 * depending on the driver and the query, and callers should not have to normalise first.
 */
export const entityId = z.union([
    z.number().int(),
    z.string().regex(/^\d+$/),
]);
//# sourceMappingURL=common.js.map